import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import { AUTH_TOKEN_KEY } from '../lib/constants';
import toast from 'react-hot-toast';

export const baseURL = process.env.REACT_APP_BASE_URL;

const httpClient: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

httpClient.interceptors.request.use(
  function (config) {
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    const token = localStorage.getItem(AUTH_TOKEN_KEY) ?? '';

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  function (response: AxiosResponse) {
    return response.data;
  },
  function (error: AxiosError) {
    if (error.response) {
      const { status, data }: { status: number; data: any } = error.response;

      switch (status) {
        case 400:
          console.log('400 Bad Request:', data.message);
          break;
        case 401:
          console.log('401 Unauthorized:', data.message);
          localStorage.clear();
          window.location.pathname = '/login';
          break;
        case 403:
          console.log('403 Forbidden:', data.message);
          break;
        case 404:
          console.log('404 Not Found:', data.message);
          break;
        case 422:
          console.log('Unprocessable Content', data.message);
          break;
        case 500:
          console.log('500 Internal Server Error:', data.message);
          break;
        default:
          console.log(`Unhandled status code ${status}:`, data.message);
          break;
      }

      // if (status === 400) {
      // toast.error('Connection Problem, check your internet');
      // } else {
      if (typeof data.message === 'string') {
        toast.error(data.message);
      } else if (typeof data.message === 'object') {
        Object.keys(data.message).forEach((key) => {
          toast.error(data.message[key][0]);
        });
      }
      // }

      return Promise.reject(error);
    } else if (error.request) {
      console.log('No response received:', error.request);
    } else {
      console.log('Error during request setup:', error.message);
    }
    return Promise.reject(error);
  }
);

export default httpClient;
